/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Icy_Cozy_Bear_StriveInputs */

const fr_icy_cozy_bear_strive = /** @type {(inputs: Icy_Cozy_Bear_StriveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Semainier`)
};

/**

* @param {Icy_Cozy_Bear_StriveInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const icy_cozy_bear_strive = /** @type {((inputs?: Icy_Cozy_Bear_StriveInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Icy_Cozy_Bear_StriveInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_icy_cozy_bear_strive(inputs)
});